import { ListItemButton, ListItemIcon } from '@mui/material';
import React from 'react';
import { AppbarContainer, AppbarHeader, MyList, LogoImage, MyNavbar, MyLink } from "../../styles/appbar";
import SearchIcon from "@mui/icons-material/Search";
import Actions from './actions';
import { useUIContext } from '../../context/ui';
import {Link} from 'react-router-dom';
import logo from '../../assets/logo.png';


export default function AppbarDesktop({matches, onLoginClick , onLogoutClick}) {
    const { setShowSearchBox} = useUIContext();

    return (
        <AppbarContainer>
            <LogoImage src={logo}></LogoImage>
        <AppbarHeader>Enxhi Healthineers</AppbarHeader>
        <MyList type="row">
        <MyNavbar>
            <MyLink><Link to="/" style={{ textDecoration: 'none' }}>Home</Link></MyLink>
            <MyLink><Link to="/Services" style={{ textDecoration: 'none' }}>Services</Link></MyLink>
            <MyLink><Link to="/Staff" style={{ textDecoration: 'none' }}>Our Staff</Link></MyLink>
            <MyLink><Link to="/About" style={{ textDecoration: 'none' }}>About us</Link></MyLink>
            <MyLink><Link to="/Contact" style={{ textDecoration: 'none' }}>Contact</Link></MyLink>
        </MyNavbar>
        </MyList>
        <ListItemButton onClick = {() => setShowSearchBox(true)}>
            <ListItemIcon >
                <SearchIcon />
            </ListItemIcon>
        </ListItemButton>
        <Actions onLogin={onLoginClick}
            onLogout={onLogoutClick}
            matches = {matches}/>
        </AppbarContainer>
    )
}